import {
  type ComponentWithAs,
  forwardRef,
  IconButton,
  type IconButtonProps,
} from "@chakra-ui/react";
import { Icon } from "@src/components/ui-kit/Icon";

export const DataTableActionButton: ComponentWithAs<"button", IconButtonProps> =
  forwardRef((props, ref) => {
    return (
      <IconButton
        ref={ref}
        icon={<Icon name="dots-vertical" />}
        variant="ghost"
        {...props}
      />
    );
  });
